<div class="kt-grid kt-grid--ver kt-grid--root kt-page" style="min-height: 100vh;">
    <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v1" id="kt_login">
        <div
            class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">

            <!--begin::Aside-->
            <div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
                style="background-color: #005BAA;">
                <div class="kt-grid__item">

                    <div class="kt-login__info">
                        <a routerLink="/login" class="kt-login__logo">
                            <img src="assets/img/bkd_siyah_zeminsiz.png" width="160" height="53"
                                style="margin-right: 30px;">
                            <img src="assets/img/boost-logo.png" width="180" height="70">
                        </a>
                        <!-- <div class="kt-login__menu">
                            <a href="https://www.bilimkahramanlari.org/iletisim/" target="_blank" class="kt-link">İletişim</a>
                            <a href="https://fonzip.com/bilimkahramanlari/bagis#/" target="_blank" class="kt-link">Bağış</a>
                            <a routerLink="/kvkk" class="kt-link">KVKK</a>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto1.jpg" style="width: 33%;">
                        <img src="assets/img/foto2.jpg" style="width: 33%;">
                        <img src="assets/img/foto3.JPG" style="width: 33%;">
                    </div>
                </div> -->
                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                    <div class="kt-grid__item kt-grid__item--fluid" style="margin-top: 25px;">
                        <h3 class="kt-login__title" style="text-align: center;">Bilim Kahramanları Derneği <br> Gönüllü
                            Portalı'na<br> Hoş Geldin!</h3>
                        <!-- <h4 class="kt-login__subtitle" style="color: #000;">Bilim Kahramanları Derneği Gönüllü Portalı'na Hoş Geldin!</h4> -->
                    </div>
                </div>
                <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto3.JPG" style="width: 100%;">
                    </div>
                </div>
                <div class="kt-grid__item" style="margin-top: 5px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto1.jpg" style="width: 50%;">
                        <img src="assets/img/foto2.jpg" style="width: 50%;">
                    </div>
                </div>
                <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto4.jpg" style="width: 100%;">
                    </div>
                </div>
                <!-- <div class="kt-grid__item">
                    <div class="kt-login__info">
                        <div class="kt-login__copyright">
                        </div>

                    </div>
                </div> -->
            </div>


            <!--begin::Aside-->

            <!--begin::Content-->
            <div
                class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">

                <!--begin::Head-->
                <div class="kt-login__head">
                    <span class="kt-login__signup-label">Hesabın var mı?</span>&nbsp;&nbsp;
                    <a routerLink="/login" class="kt-link kt-login__signup-link">Giriş yap!</a>
                </div>

                <!--end::Head-->

                <!--begin::Body-->
                <div class="kt-login__body">

                    <!--begin::Signin-->
                    <div class="kt-login__form">
                        <div class="kt-login__title">
                            <h3>Kayıt Ol</h3>
                        </div>

                        <!--begin::Form-->
                        <form [formGroup]="registerForm" (ngSubmit)="register()" class="kt-form" id="kt_login_form">
                            <div class="form-group">
                                <label for="fullName" class="col-form-label">Ad Soyad</label>
                                <input formControlName="fullName" class="form-control" type="text"
                                    placeholder="Ad Soyad" name="fullName" autocomplete="off">
                                <small class="form-text text-warning" *ngIf="f.fullName.errors?.required">Lütfen ad
                                    soyad giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.fullName.errors?.minlength">Lütfen en az
                                    5 en fazla 100 haneli bir isim giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.fullName.errors?.maxlength">Lütfen en az
                                    5 en fazla 100 haneli bir isim giriniz!</small>
                            </div>
                            <div class="form-group">
                                <label for="gender" class="col-form-label">Cinsiyet</label>
                                <ng-select name="gender" id="gender" labelForId="gender" bindValue="code"
                                    class="form-control" [items]="genderTypes" bindLabel="text" formControlName="gender"
                                    placeholder="Cinsiyet..">
                                </ng-select>
                                <small class="form-text text-warning" *ngIf="f.gender.errors?.required">Lütfen cinsiyet
                                    seçiniz!</small>
                            </div>

                            <div class="form-group">
                                <label for="birthDate" class="col-form-label">Doğum tarihi</label>
                                <input class="form-control" type="date" [(ngModel)]="model.birthDate" id="birthDate"
                                    formControlName="birthDate" placeholder="Doğum Tarihi" name="birthDate">
                                <small class="form-text text-warning" *ngIf="f.birthDate.errors?.required">Lütfen doğum
                                    tarihi giriniz!</small>
                            </div>

                            <div class="form-group">
                                <label for="email" class="col-form-label">Email</label>
                                <input class="form-control" type="text" placeholder="Email" formControlName="email"
                                    name="email" autocomplete="off">
                                <small class="form-text text-warning" *ngIf="f.email.errors?.required">Lütfen email
                                    adresi giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.email.errors?.pattern">Lütfen geçerli bir
                                    email adresi giriniz!</small>
                            </div>

                            <div class="form-group">
                                <label for="password" class="col-form-label">Şifre</label>
                                <input class="form-control" type="password" formControlName="password"
                                    placeholder="Şifre" name="password" autocomplete="off">
                                <small class="form-text text-warning" *ngIf="f.password.errors?.required">Lütfen şifre
                                    giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.password.errors?.minlength">Lütfen en az
                                    8 en fazla 20 haneli bir şifre giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.password.errors?.maxlength">Lütfen en az
                                    8 en fazla 20 haneli bir şifre giriniz!</small>
                            </div>

                            <div class="form-group">
                                <label for="phone" class="col-form-label">Telefon</label>
                                <input class="form-control" type="text" formControlName="phone" placeholder="5XXXXXXXXX"
                                    name="phone" autocomplete="off">
                                <small class="form-text text-warning" *ngIf="f.phone.errors?.required">Lütfen telefon
                                    numaranızı
                                    giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.phone.errors?.minlength">Lütfen 10 haneli
                                    (5XXXXXXXXX) telefon numaranızı giriniz!</small>
                                <small class="form-text text-warning" *ngIf="f.phone.errors?.maxlength">Lütfen 10 haneli
                                    (5XXXXXXXXX) telefon numaranızı giriniz!</small>
                            </div>

                            <div class="form-group">
                                <label for="primaryCityId" class="col-form-label">Şehir</label>
                                <ng-select name="primaryCityId" id="primaryCityId" labelForId="primaryCityId"
                                    bindValue="id" class="form-control" placeholder="Şehir" [items]="cities"
                                    bindLabel="name" formControlName="primaryCityId">
                                </ng-select>
                                <small class="form-text text-warning" *ngIf="f.primaryCityId.errors?.required">Lütfen
                                    şehir seçiniz!</small>
                            </div>
                            <div class="form-group" style="margin-top: 15px;">
                                <label class="kt-checkbox w-100">
                                    <input type="checkbox" name="isAlumni" class="form-control"
                                        formControlName="isAlumni">
                                    Bilim Kahramanlari programı mezunu musun?
                                    <span></span>
                                </label>
                            </div>
                            <div class="form-group">
                                <label for="educationType" class="col-form-label">Eğitim durumunuz</label>
                                <ng-select name="type" id="educationType" labelForId="educationType" bindValue="code"
                                    class="form-control" [items]="educationTypes" bindLabel="text"
                                    [(ngModel)]="model.educationLevel" (change)="educationLevel()"
                                    placeholder="Eğitim durumunuz.." formControlName="educationLevel">
                                </ng-select>
                                <small class="form-text text-warning" *ngIf="f.educationLevel.errors?.required">Lütfen
                                    eğitim seviyesi seçiniz!</small>
                            </div>

                            <div class="form-group" *ngIf="isUniversity">
                                <label for="universityId" class="col-form-label">Üniversite</label>
                                <ng-select name="universityId" id="universityId" labelForId="universityId"
                                    bindValue="id" class="form-control" placeholder="Üniversite" [items]="universities"
                                    bindLabel="name" formControlName="universityId">
                                </ng-select>
                            </div>

                            <div class="form-group" style="margin-top: 15px;" *ngIf="isUniversity">
                                <label class="kt-checkbox w-100">
                                    <input type="checkbox" name="isOtherUniversity" class="form-control"
                                        formControlName="isOtherUniversity" (change)="otherUniversity()"
                                        [(ngModel)]="model.isOtherUniversity">
                                    Diğer
                                    <span></span>
                                </label>
                            </div>

                            <div class="form-group" *ngIf="isSchoolName">
                                <label for="schoolName" class="col-form-label">Kurum/Okul adı</label>
                                <input formControlName="schoolName" class="form-control" type="text"
                                    placeholder="Kurum/Okul adı" name="schoolName" autocomplete="off">
                            </div>

                            <div class="form-group" *ngIf="isDepartmant">
                                <label for="departmant" class="col-form-label">Bölüm/Alan</label>
                                <input class="form-control" type="text" formControlName="departmant"
                                    placeholder="Bölüm/Alan" name="departmant" autocomplete="off">
                            </div>

                            <div class="form-group">
                                <label for="professionType" class="col-form-label">Çalışma durumunuz</label>
                                <ng-select name="type" id="professionType" labelForId="professionType" bindValue="code"
                                    class="form-control" [items]="professionTypes" bindLabel="text"
                                    [(ngModel)]="model.professionType" formControlName="professionType"
                                    (change)="workingStatus()" placeholder="Çalışma durumunuz..">
                                </ng-select>
                                <small class="form-text text-warning" *ngIf="f.professionType.errors?.required">Lütfen
                                    çalışma durumunuzu seçiniz!</small>
                            </div>

                            <div class="form-group" *ngIf="isWorking">
                                <label for="company" class="col-form-label">Kurum/Firma adı</label>
                                <input formControlName="company" class="form-control" type="text"
                                    placeholder="Kurum/Firma adı" name="company" autocomplete="off">
                            </div>

                            <div class="form-group" *ngIf="isWorking">
                                <label for="company" class="col-form-label">Çalışma pozisyonunuz</label>
                                <input formControlName="position" class="form-control" type="text"
                                    placeholder="Çalışma pozisyonunuz" name="position" autocomplete="off">
                            </div>

                            <div class="form-group">
                                <label for="categoryId" class="col-form-label">Lütfen gönüllülük yapmak istediğiniz
                                    alanları seçiniz</label>
                                <ng-select name="categoryId" id="categoryId" labelForId="categoryId" bindValue="id"
                                    class="form-control"
                                    placeholder="Gönüllülük alanları" [items]="volunteerCategories"
                                    bindLabel="categoryName" [multiple]="true" formControlName="selectedCategories">
                                </ng-select>
                            </div>
                            <div class="form-group" style="margin-top: 15px;">
                                <label class="kt-checkbox w-100">
                                    <input type="checkbox" name="isKvkk" class="form-control" formControlName="isKvkk">
                                    <a routerLink="/kvkk" target="_blank"><b>KVKK katılım koşullarını</b></a>
                                    onaylıyorum. <i class="fa fa-info-circle" style="cursor: pointer !important"></i>
                                    <span></span>
                                </label>
                                <small class="form-text text-warning" *ngIf="f.isKvkk.errors?.requiredTrue">Lütfen KVKK
                                    katılım koşullarını onaylayınız!</small>
                            </div>
                            <div class="form-group" style="margin-top: 15px;">
                                <label class="kt-checkbox w-100">
                                    <input type="checkbox" name="isTermsAndUsage" class="form-control"
                                        formControlName="isTermsAndUsage">
                                    <a routerLink="/terms-and-usage" target="_blank"><b>Kullanım koşullarını</b></a>
                                    okudum, onaylıyorum. <i class="fa fa-info-circle"
                                        style="cursor: pointer !important"></i>
                                    <span></span>
                                </label>
                                <small class="form-text text-warning"
                                    *ngIf="f.isTermsAndUsage.errors?.requiredTrue">Lütfen kullanım koşullarını
                                    onaylayınız!</small>
                            </div>
                            <div class="form-group" style="margin-top: 15px;">
                                <label class="kt-checkbox w-100">
                                    <input type="checkbox" name="isElectronicMessage" class="form-control"
                                        formControlName="isElectronicMessage">
                                    <b>Ticari, elektronik ileti</b> almaya izin veriyorum. <i class="fa fa-info-circle"
                                        style="cursor: pointer !important"></i>
                                    <span></span>
                                </label>
                                <small class="form-text text-warning"
                                    *ngIf="f.isElectronicMessage.errors?.requiredTrue">Lütfen ticari ve elektronik ileti
                                    almaya izin veriniz!</small>
                            </div>

                            <!--begin::Action-->
                            <div class="kt-login__actions">
                                <button type="submit" id="kt_login_signin_submit"
                                    class="btn btn-primary btn-elevate kt-login__btn-primary">Kayıt Ol</button>
                            </div>


                            <!--end::Action-->
                        </form>

                        <!--end::Form-->

                    </div>

                    <!--end::Signin-->
                </div>

                <!--end::Body-->
            </div>

            <!--end::Content-->
        </div>
    </div>
</div>